<style lang="less" scoped>
  @import "../../../style/theme.less";

</style>

<template>
  <div>
    <a-page-header title="Submissions" style="padding: 0; margin-bottom: 18px">
      <template slot="extra">
        <a-button type="primary" shape="circle" icon="reload" @click="updateSubmissionList" />
      </template>
    </a-page-header>

    <a-table
      :columns="columns"
      :data-source="submissions"
      :pagination="pagination"
      :rowKey="({ id }) => id"
      @change="updateSubmissionList"
    >
      <a-icon slot="completed" slot-scope="data" :type="data ? 'check' : 'close'"/>

      <span slot="gender" slot-scope="data">{{ data | capitalise }}</span>
      <span slot="timestamp" slot-scope="data">{{ data | timestamp }}</span>

      <a-button
        type="primary"
        shape="circle"
        icon="exclamation-circle"
        slot="details"
        slot-scope="{ id }"
        @click="() => $router.push({name:'admin.submissions.details', params: { id }})"
      />
    </a-table>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    ellipsis: true,
  }, {
    title: 'License Key',
    dataIndex: 'licenseKey',
    ellipsis: true,
  }, {
    title: 'Gender',
    dataIndex: 'gender',
    ellipsis: true,
    scopedSlots: { customRender: 'gender', },
  }, {
    title: 'Age',
    dataIndex: 'age',
    ellipsis: true,
  }, {
    title: 'Completed',
    dataIndex: 'completed',
    scopedSlots: { customRender: 'completed', },
  },{
    title: 'Created At',
    dataIndex: 'createdAt',
    scopedSlots: { customRender: 'timestamp', },
  }, {
    title: 'Updated At',
    dataIndex: 'updatedAt',
    scopedSlots: { customRender: 'timestamp', },
  }, {
    width: '75px',
    scopedSlots: { customRender: 'details', },
  },
];

export default {
  name: 'admin.submissions',

  data: () => ({
    columns,

    pagination: {
      current: 1,
      position: 'bottom',
      pageSize: 10,
      size: 'small',
      total: 0,
      showSizeChanger: true,
      pageSizeOptions: ['10', '20', '50',],
      showTotal: (total, range) => `${range.join('-')} of ${total}`,
    },
  }),

  mounted() {
    return this.updateSubmissionList();
  },

  computed: mapState('admin', ['submissions',]),

  methods: {
    ...mapActions('admin', ['listSubmissions',]),

    updateSubmissionList({ current = this.pagination.current, pageSize = this.pagination.pageSize, } = {}) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;

      return this.listSubmissions({
        query: {
          $limit: pageSize,
          $skip: (current - 1) * pageSize,
          $sort: {
            createdAt: -1,
          },
        },
      })
        .then(({ total, }) => {
          this.pagination.total = total;
        });
    },
  },
};
</script>
